import { Box } from "@chakra-ui/react";

import { AccountCard } from "../AccountCard";

export const Sidebar = () => (
  <Box>
    <AccountCard />
  </Box>
);
